import { Flex, RootScreen, Spinner } from '@banhala/ui-kit';
import { HomeContents } from './components';
import { Suspense } from 'react';
import { HomeHeader } from './components/HomeHeader';

export const HomeScreen = () => {
  return (
    <RootScreen>
      <HomeHeader />

      <Flex flex={1}>
        <Suspense fallback={<Spinner />}>
          <HomeContents />
        </Suspense>
      </Flex>
    </RootScreen>
  );
};
